import React, { useState } from "react";
import styles from "./styles.module.css";
import { ProductionPlantsMap } from "../../productionMap";
import { 
    ProductionPlants, 
  } from "../../../tables/index";
import ZernoProdChart from "../../../tables/plants/ProductionSchedule/zerno";
import WheatProdChart from "../../../tables/plants/ProductionSchedule/wheat";
import BarleyProdChart from "../../../tables/plants/ProductionSchedule/barley";
import MaizeProdChart from "../../../tables/plants/ProductionSchedule/maize";
import RiceProdChart from "../../../tables/plants/ProductionSchedule/rice";
import LegumesProdChart from "../../../tables/plants/ProductionSchedule/Legumes";
import SugarProdChart from "../../../tables/plants/ProductionSchedule/sugarbeet";
import CottonProdChart from "../../../tables/plants/ProductionSchedule/rawcotton";
import TobaccoProdChart from "../../../tables/plants/ProductionSchedule/tobacco";
import OilseedsProdChart from "../../../tables/plants/ProductionSchedule/oilseeds";
import PotatoProdChart from "../../../tables/plants/ProductionSchedule/potato";
import VegetablesProdChart from "../../../tables/plants/ProductionSchedule/vegetables";
import MelonsProdChart from "../../../tables/plants/ProductionSchedule/foodmelons";
import FruitsandBerriesProdChart from "../../../tables/plants/ProductionSchedule/fruitsandberries";
import GrapeProdChart from "../../../tables/plants/ProductionSchedule/grape";
import styled from "styled-components";
import { Button } from "antd";

const Container = styled.div`
  position: relative;
  height: 100%;
`;

const Content = styled.div`
  padding-top: 60px; /* Отступ под кнопки */
`;

const ButtonContainer = styled.div`
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 999;
`;

export const TotalProductionPlants = () => {
  const [collapsed, setCollapsed] = useState(false);

  
  const [activeTab, setActiveTab] = useState<"map" | "statistics">("map");

 
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };


  const handleTabChange = (tab: "map" | "statistics") => {
    setActiveTab(tab);
  };

  return (
    <Container>
      {/* <Sidebar collapsed={collapsed} /> */}
      <Content>
        <ButtonContainer>
          <Button
            type={activeTab === "map" ? "primary" : "default"}
            onClick={() => handleTabChange("map")}
          >
            Карта
          </Button>
          <Button
            type={activeTab === "statistics" ? "primary" : "default"}
            onClick={() => handleTabChange("statistics")}
          >
            Статистика и аналитика
          </Button>
        </ButtonContainer>

        {activeTab === "map" ? (
          <div className={styles.mapBackground}>
            <ProductionPlantsMap latitude={41.5089324} longitude={74.724091} />
           
            <ProductionPlants/>
          </div>
        ) : (
            <div className={styles.tables_production_plants}>
               <h2>Данные по производству сельско хозяйственной продукции по областям (тонн)</h2>
          {/* <ProductionPlantsChart /> */}
          <ZernoProdChart/> 
          <WheatProdChart/>
          <BarleyProdChart/>
          <MaizeProdChart/>
          <RiceProdChart/>
          <LegumesProdChart/>
          <SugarProdChart/>
          <CottonProdChart/>
          <TobaccoProdChart/>
          <OilseedsProdChart/>
          <PotatoProdChart/>
          <VegetablesProdChart/>
          <MelonsProdChart/>
          <FruitsandBerriesProdChart/>
          <GrapeProdChart/>
        
         </div>
        )}
      </Content>
    </Container>
  );
};
